import { MOCK_RECIPES } from '../../api/availableViews.mock';
import type { DefectCatalogItem } from '../../contracts/availableLayers';
import { mergePas2161CatalogDefects } from '../../pas2161/mergePas2161Catalog';
import {
  PAS2161_PASSES,
  PAS2161_REGIONS,
} from '../../pas2161/pas2161LayerModel';
import type { TenantDefectOverlayAdapter } from '../tenantDefectOverlayAdapter';

export const PAS2161_OVERLAY_TENANT_SLUG = 'pas-2161' as const;

const PAS2161_REGION_RECIPE_SUFFIXES = [
  'mini-potholes',
  'mini-longitudinal',
  'mini-transversal',
  'mini-alligator',
  'mini-patches',
  'mini-iron-work',
  'mfv-cracking-relaxed',
  'mfv-cracking-accred',
] as const;

export const PAS2161_OVERLAY_RECIPE_IDS: ReadonlySet<string> = new Set(
  PAS2161_REGIONS.flatMap((region) =>
    PAS2161_REGION_RECIPE_SUFFIXES.flatMap((suffix) =>
      PAS2161_PASSES.map((pass) => `pts-pas2161-${region}-${suffix}-${pass}`),
    ),
  ),
);

function mergePas2161Catalog(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  return mergePas2161CatalogDefects(defects, surveyTypes);
}

export const pas2161DefectOverlayAdapter: TenantDefectOverlayAdapter = {
  id: 'pas2161-overlays',
  tenantSlug: PAS2161_OVERLAY_TENANT_SLUG,
  recipeIds: PAS2161_OVERLAY_RECIPE_IDS,
  mergeCatalog: mergePas2161Catalog,
  getRecipes: () =>
    MOCK_RECIPES.filter((recipe) => PAS2161_OVERLAY_RECIPE_IDS.has(recipe.id)),
};
